export default __webpack_public_path__ + "static/media/pellets-icon.2f43d43a.svg";